import { useNavigate } from 'react-router-dom';

export default function Error404() {

  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const usertype = parseInt(localStorage.getItem('usertype'),10) ;
  const handleBackToHomePage = () => {
  
    if (token !== null) {
      // User is logged in, redirect to the dashboard
          if(usertype===3){
          navigate('/studentdashboard');
          }
          else if (usertype===2) {
            navigate('/college/collegedashboard');
          }
          else if (usertype===1) {
            navigate('/admin/dashboard');
          }
          else{
            navigate('/');

          }

    } else {
      // User is not logged in, redirect to the login page
      navigate('/');
    }
  };
  return (
    <>
      
        {/* Container-fluid starts*/}
        <div className="container-fluid">
          {/* error-404 start*/}
          <div className="error-wrapper">
                <div className="container">
                <div className="row">
                  <div className="col-xl-12 col-md-12 col-sm-12">
                  <div className="error-heading">
                    <h2 className="headline font-danger error-heading-sz">404</h2>
                  </div>
                    <p className="sub-content">The page you are attempting to reach is currently not available. This may be because the page does not exist or has been moved.</p>
                  
                  <div>
                     {/* Use onClick handler to handle redirection */}
              <button className="btn btn-danger-gradien btn-lg" onClick={handleBackToHomePage}>BACK TO HOME PAGE</button></div>
                </div>
                </div>
              </div>
              </div>
              {/* error-404 end      */}
        </div>
        {/* Container-fluid Ends*/}
     
    </>




  );
}
